import { getStoreValue } from 'pixel-react';

import type { LicenseDetailResponse } from './types';

export const LICENSE_TYPE = getStoreValue(
  'test-optimize-user',
) as LicenseDetailResponse;
export const BEFORE_RUNNING_STATUSES: string[] = [
  'Initializing Execution',
  'Initialized',
  'Parallel Runs Exceeded for license',
  'Client is busy',
  'Awaiting Client Acknowledgement',
  'Client Acknowledged',
  'Preparing client for execution',
  'Updating client libraries',
  'Client Restarting',
  'Queued',
  'Exceeded',
  'Checking...',
  'Pending',
];

export const MACHINE_DETAILS_KEY = {
  os: 'OS',
  browser: 'Browser',
  device: 'Device',
  owner: 'Owner',
};
export const USER_DETAILS_KEY = {
  name: 'Name',
  email: 'Email',
  privilege: 'Privilege',
  status: 'Status',
  createdBy: 'Created By',
  createdOn: 'Created On',
  modifiedBy: 'Modified By',
  modifiedOn: 'Modified On',
};

export const UPGRADE_FORM_SUBMITTED_MESSAGE =
  'Your request has already been submitted. Our team will contact you soon';
